import { useContext } from 'react';
import { MapSearchContext } from './MapSearchContext.js';
import Essentials from '../../../images/donor-map/filter-point-essentials.svg';

import { Svg } from '../common/Svg.js';

export const MapToggleButton = function() {
    const context = useContext(MapSearchContext);

    return (
        <button tabIndex="0" role="button" aria-label="view classroom essentials only" className='button-secondary small essentials'
                id='toggle-button' type='button'
                onClick={context.toggleDisplayEssentialsOnly}>
                <div className="filter-box">
                    <div className="filter-image">
                        <Essentials/>
                    </div>
                    <div className="filter-description">
                        <div className="title">Classroom Essentials</div>
                        <p>Help teachers get essential, fast-shipping supplies.</p>
                    </div>
                </div>
        </button>
    );
};
